import { render, staticRenderFns } from "./EncerradosPorPeriodo.vue?vue&type=template&id=46870b51&scoped=true&"
import script from "./EncerradosPorPeriodo.vue?vue&type=script&lang=js&"
export * from "./EncerradosPorPeriodo.vue?vue&type=script&lang=js&"
import style0 from "./EncerradosPorPeriodo.vue?vue&type=style&index=0&id=46870b51&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46870b51",
  null
  
)

export default component.exports